export const movies = [
  {
    id: "m01",
    title: "星海孤舟",
    type: "movie",
    year: 2024,
    region: "中国大陆",
    rating: 8.9,
    views: 4820000,
    genres: ["科幻", "冒险"],
    tags: ["太空", "硬核科幻", "视觉盛宴"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20lone%20astronaut%20standing%20before%20a%20glowing%20nebula%2C%20deep%20black%20space%20background%2C%20dramatic%20orange%20rim%20lighting%2C%20ultra%20detailed%20vertical%20portrait%20layout%2C%20elegant%20minimal%20film%20poster%20design%2C%20moody%20atmosphere%2C%20high%20contrast&width=480&height=672&seq=yz-poster-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20still%20of%20a%20spacecraft%20drifting%20near%20a%20luminous%20nebula%2C%20deep%20dark%20cosmic%20background%2C%20dramatic%20orange%20and%20amber%20lighting%2C%20atmospheric%20haze%2C%20ultra%20detailed%20key%20art%2C%20wide%20landscape%20composition&width=1280&height=720&seq=yz-back-01&orientation=landscape",
    summary:
      "一艘失联多年的探索飞船在深空被唤醒，仅存的船员必须在资源耗尽前找到回家的航线。影片以硬核科学设定与壮阔宇宙景观交织，讲述孤独与信念的远征。",
    director: "陆承宇",
    cast: ["林墨白", "苏晚晴", "魏子骁"],
    duration: "132分钟",
    updatedAt: "2024-09-28",
    featured: true,
  },
  {
    id: "m02",
    title: "暗涌之城",
    type: "movie",
    year: 2023,
    region: "中国香港",
    rating: 8.2,
    views: 3160000,
    genres: ["犯罪", "悬疑"],
    tags: ["警匪", "港片", "反转"],
    poster:
      "https://readdy.ai/api/search-image?query=Neo%20noir%20crime%20movie%20poster%20of%20a%20rain%20soaked%20city%20alley%20at%20night%2C%20silhouette%20of%20a%20man%20in%20a%20long%20coat%2C%20deep%20teal%20and%20black%20tones%20with%20orange%20neon%20reflections%2C%20moody%20vertical%20film%20poster%2C%20highly%20detailed&width=480&height=672&seq=yz-poster-02&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Rainy%20night%20neon%20lit%20harbor%20city%20skyline%20in%20the%20dark%2C%20reflections%20on%20wet%20streets%2C%20deep%20navy%20and%20orange%20neon%20glow%2C%20cinematic%20crime%20thriller%20wide%20shot%2C%20atmospheric%20haze%2C%20moody%20high%20contrast&width=1280&height=720&seq=yz-back-02&orientation=landscape",
    summary:
      "一桩看似普通的走私案，牵出横跨半岛的黑色网络。坚持真相的老刑警与来历成谜的搭档，在霓虹与暗流交织的城市里步步逼近幕后黑手。",
    director: "陈启铭",
    cast: ["黄振邦", "邓皓然", "何嘉雯"],
    duration: "118分钟",
    updatedAt: "2024-08-15",
  },
  {
    id: "m03",
    title: "逆光飞行",
    type: "movie",
    year: 2024,
    region: "美国",
    rating: 8.6,
    views: 5290000,
    genres: ["剧情", "励志"],
    tags: ["航空", "梦想", "治愈"],
    poster:
      "https://readdy.ai/api/search-image?query=Inspirational%20drama%20movie%20poster%20of%20a%20young%20pilot%20silhouetted%20against%20a%20golden%20sunset%20sky%2C%20airplane%20wing%20in%20foreground%2C%20warm%20amber%20and%20deep%20dark%20background%2C%20hopeful%20cinematic%20portrait%20poster%20layout&width=480&height=672&seq=yz-poster-03&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Golden%20hour%20sky%20above%20clouds%20seen%20from%20an%20airplane%20cockpit%2C%20warm%20amber%20sunlight%20and%20deep%20shadowed%20clouds%2C%20cinematic%20wide%20drama%20still%2C%20inspiring%20atmosphere%2C%20highly%20detailed&width=1280&height=720&seq=yz-back-03&orientation=landscape",
    summary:
      "出身小镇的女飞行学员，用一次次逆风起降证明自己。面对质疑与失败，她在云端之上重新定义了什么叫做勇气与热爱。",
    director: "Jonathan Reeves",
    cast: ["Emily Hart", "Marcus Lane", "Sofia Kerr"],
    duration: "141分钟",
    updatedAt: "2024-10-02",
    featured: true,
  },
  {
    id: "m04",
    title: "长安幻夜",
    type: "movie",
    year: 2023,
    region: "中国大陆",
    rating: 7.9,
    views: 2780000,
    genres: ["奇幻", "古装"],
    tags: ["盛唐", "志怪", "东方奇幻"],
    poster:
      "https://readdy.ai/api/search-image?query=Chinese%20fantasy%20wuxia%20movie%20poster%20of%20an%20ancient%20Tang%20dynasty%20city%20glowing%20at%20night%2C%20lanterns%20and%20mist%2C%20a%20robed%20figure%20with%20a%20sword%2C%20deep%20black%20and%20warm%20orange%20tones%2C%20vertical%20epic%20poster%20composition&width=480&height=672&seq=yz-poster-04&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Mystical%20ancient%20Chinese%20city%20at%20night%20with%20glowing%20lanterns%20and%20drifting%20mist%2C%20oriental%20palace%20rooftops%2C%20deep%20dark%20background%20with%20warm%20amber%20glow%2C%20cinematic%20fantasy%20wide%20shot%2C%20highly%20detailed&width=1280&height=720&seq=yz-back-04&orientation=landscape",
    summary:
      "盛唐长安的夜晚，一个落魄书生与一位神秘女子卷入妖异连环迷案。幻夜之下，人与妖的界限逐渐模糊，真相藏在灯火照不到的角落。",
    director: "顾青山",
    cast: ["沈逸舟", "白寥寥", "程远"],
    duration: "126分钟",
    updatedAt: "2024-07-20",
  },
  {
    id: "m05",
    title: "沉默回响",
    type: "movie",
    year: 2022,
    region: "英国",
    rating: 8.4,
    views: 2460000,
    genres: ["悬疑", "惊悚"],
    tags: ["心理", "小镇", "谜案"],
    poster:
      "https://readdy.ai/api/search-image?query=Psychological%20thriller%20movie%20poster%20of%20a%20foggy%20english%20village%20at%20dusk%2C%20lone%20figure%20walking%20a%20deserted%20road%2C%20cold%20desaturated%20tones%20with%20a%20hint%20of%20amber%20light%2C%20moody%20vertical%20poster%20layout&width=480&height=672&seq=yz-poster-05&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Misty%20isolated%20british%20countryside%20village%20at%20dusk%2C%20bare%20trees%20and%20old%20stone%20houses%2C%20cold%20dark%20atmosphere%20with%20warm%20window%20lights%2C%20cinematic%20mystery%20wide%20shot%2C%20highly%20detailed&width=1280&height=720&seq=yz-back-05&orientation=landscape",
    summary:
      "一位听力康复师回到童年小镇，却发现当年那场让全镇沉默的意外另有隐情。声音可以消失，但回响从不真正停止。",
    director: "Alastair Finch",
    cast: ["Grace Whitfield", "Daniel Moore", "Hannah Bell"],
    duration: "109分钟",
    updatedAt: "2024-05-30",
  },
  {
    id: "m06",
    title: "夏日来信",
    type: "movie",
    year: 2024,
    region: "日本",
    rating: 8.1,
    views: 2090000,
    genres: ["爱情", "剧情"],
    tags: ["治愈", "青春", "海边"],
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20japanese%20drama%20movie%20poster%20of%20a%20girl%20holding%20a%20letter%20on%20a%20sunny%20seaside%20road%2C%20soft%20warm%20light%2C%20gentle%20pastel%20sky%20and%20deep%20shadowed%20background%2C%20tender%20vertical%20film%20poster%20composition&width=480&height=672&seq=yz-poster-06&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Sunset%20seaside%20town%20in%20summer%20with%20calm%20sea%20and%20warm%20golden%20sky%2C%20bicycle%20on%20an%20empty%20coastal%20road%2C%20warm%20amber%20tones%20with%20soft%20shadows%2C%20cinematic%20romance%20wide%20shot%2C%20highly%20detailed&width=1280&height=720&seq=yz-back-06&orientation=landscape",
    summary:
      "每年夏天，女孩都会收到一封没有署名的信。直到那年海风再起，她才终于明白，写信的人一直都在离她最近的地方。",
    director: "中村涼介",
    cast: ["小林遥", "佐藤悠真", "田中美咲"],
    duration: "115分钟",
    updatedAt: "2024-09-12",
    featured: true,
  },
  {
    id: "t01",
    title: "江湖夜行录",
    type: "tv",
    year: 2024,
    region: "中国大陆",
    rating: 9.0,
    views: 7320000,
    genres: ["武侠", "古装"],
    tags: ["江湖", "群像", "复仇"],
    poster:
      "https://readdy.ai/api/search-image?query=Chinese%20wuxia%20tv%20series%20poster%20of%20a%20swordsman%20in%20dark%20robes%20standing%20on%20a%20mountain%20cliff%20under%20the%20moon%2C%20flowing%20fabric%2C%20deep%20black%20background%20with%20orange%20moonlight%2C%20epic%20vertical%20poster%20layout&width=480&height=672&seq=yz-poster-07&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Moonlit%20ancient%20chinese%20mountain%20pass%20with%20a%20lone%20swordsman%20silhouette%2C%20mist%20and%20pine%20trees%2C%20deep%20dark%20blue%20night%20with%20warm%20amber%20torch%20glow%2C%20cinematic%20wuxia%20wide%20shot%2C%20highly%20detailed&width=1280&height=720&seq=yz-back-07&orientation=landscape",
    summary:
      "江湖动荡，一夜之间满门覆灭的少侠带着一把无名剑踏入是非之地。恩怨、情义与宿命交织，他必须选择成为哪种传说。",
    director: "郑云舟",
    cast: ["萧怀瑾", "叶轻雪", "陆惊鸿"],
    duration: "全36集",
    episodes: [
      "第1集", "第2集", "第3集", "第4集", "第5集", "第6集",
      "第7集", "第8集", "第9集", "第10集", "第11集", "第12集",
    ],
    updatedAt: "2024-10-08",
    featured: true,
  },
  {
    id: "t02",
    title: "都市浮生",
    type: "tv",
    year: 2023,
    region: "中国大陆",
    rating: 7.8,
    views: 3540000,
    genres: ["都市", "剧情"],
    tags: ["写实", "职场", "群像"],
    poster:
      "https://readdy.ai/api/search-image?query=Modern%20urban%20drama%20series%20poster%20of%20executives%20walking%20through%20a%20glass%20office%20lobby%20at%20night%2C%20cool%20dark%20tones%20with%20warm%20orange%20accent%20light%2C%20vertical%20cinematic%20poster%20layout&width=480&height=672&seq=yz-poster-08&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Night%20city%20business%20district%20skyline%20with%20lit%20skyscrapers%2C%20reflections%20on%20wet%20glass%2C%20deep%20dark%20tones%20with%20warm%20orange%20glow%2C%20cinematic%20urban%20drama%20wide%20shot%2C%20highly%20detailed&width=1280&height=720&seq=yz-back-08&orientation=landscape",
    summary:
      "五个在大城市打拼的普通人，各自背负着生活的重量。命运的齿轮把他们推到同一栋楼里，浮生百态就此展开。",
    director: "周敬川",
    cast: ["何止", "乔冉", "梁子谦"],
    duration: "全40集",
    episodes: [
      "第1集", "第2集", "第3集", "第4集", "第5集", "第6集",
      "第7集", "第8集", "第9集", "第10集", "第11集", "第12集",
    ],
    updatedAt: "2024-06-18",
  },
  {
    id: "t03",
    title: "深蓝密码",
    type: "tv",
    year: 2024,
    region: "中国大陆",
    rating: 8.5,
    views: 4980000,
    genres: ["谍战", "悬疑"],
    tags: ["烧脑", "年代", "暗战"],
    poster:
      "https://readdy.ai/api/search-image?query=Period%20spy%20thriller%20series%20poster%20of%20a%20man%20in%20a%20long%20coat%20and%20hat%20in%20a%20dark%20rainy%20street%20under%20a%20street%20lamp%2C%20moody%20dark%20teal%20and%20amber%20tones%2C%20vertical%20cinematic%20poster%20layout&width=480&height=672&seq=yz-poster-09&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Foggy%20old%20city%20street%20at%20night%20with%20vintage%20lamps%20and%20wet%20cobblestones%2C%20distant%20silhouettes%2C%20deep%20teal%20dark%20tone%20with%20warm%20amber%20light%2C%20cinematic%20spy%20thriller%20wide%20shot&width=1280&height=720&seq=yz-back-09&orientation=landscape",
    summary:
      "一份被截获的密电牵动多方势力，潜伏在敌营深处的无名者，必须在暴露前完成最后一次传递。每一次眼神交汇都是生死博弈。",
    director: "孙博远",
    cast: ["顾惟安", "方沐雪", "蒋正"],
    duration: "全32集",
    episodes: [
      "第1集", "第2集", "第3集", "第4集", "第5集", "第6集",
      "第7集", "第8集", "第9集", "第10集", "第11集", "第12集",
    ],
    updatedAt: "2024-10-05",
    featured: true,
  },
  {
    id: "t04",
    title: "雾都疑影",
    type: "tv",
    year: 2023,
    region: "英国",
    rating: 8.7,
    views: 2870000,
    genres: ["悬疑", "犯罪"],
    tags: ["英剧", "推理", "古典"],
    poster:
      "https://readdy.ai/api/search-image?query=Victorian%20mystery%20series%20poster%20of%20a%20detective%20with%20an%20umbrella%20in%20a%20foggy%20london%20street%2C%20gas%20lamps%20glowing%2C%20dark%20desaturated%20tones%20with%20amber%20light%2C%20vertical%20period%20poster%20layout&width=480&height=672&seq=yz-poster-10&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Foggy%20victorian%20london%20street%20at%20night%20with%20gas%20lamps%20and%20old%20brick%20buildings%2C%20thick%20mist%2C%20cold%20dark%20tones%20with%20warm%20amber%20glow%2C%20cinematic%20mystery%20wide%20shot&width=1280&height=720&seq=yz-back-10&orientation=landscape",
    summary:
      "浓雾笼罩的旧城接连发生离奇命案，一位落魄的推理学者与警探联手，在层层迷雾中寻找那只看不见的手。",
    director: "Eleanor Croft",
    cast: ["Arthur Pemberton", "Clara Nightingale", "Rupert Hale"],
    duration: "全10集",
    episodes: [
      "第1集", "第2集", "第3集", "第4集", "第5集",
      "第6集", "第7集", "第8集", "第9集", "第10集",
    ],
    updatedAt: "2024-04-22",
  },
  {
    id: "t05",
    title: "心跳界线",
    type: "tv",
    year: 2024,
    region: "韩国",
    rating: 8.0,
    views: 2330000,
    genres: ["爱情", "职场"],
    tags: ["甜剧", "医疗", "成长"],
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20korean%20drama%20series%20poster%20of%20a%20young%20doctor%20and%20a%20woman%20in%20a%20hospital%20corridor%2C%20soft%20warm%20light%2C%20clean%20modern%20dark%20background%20with%20gentle%20amber%20accents%2C%20vertical%20poster%20layout&width=480&height=672&seq=yz-poster-11&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Modern%20hospital%20corridor%20with%20soft%20warm%20light%20at%20dusk%2C%20clean%20minimal%20interior%2C%20deep%20muted%20tones%20with%20warm%20amber%20highlights%2C%20cinematic%20romance%20drama%20wide%20shot&width=1280&height=720&seq=yz-back-11&orientation=landscape",
    summary:
      "一位严谨冷静的心外科医生，遇上了总在关键时刻打乱他节奏的新人护理师。心跳的界线，究竟该由谁来定义。",
    director: "박서준",
    cast: ["이도현", "김하늘", "정우성"],
    duration: "全16集",
    episodes: [
      "第1集", "第2集", "第3集", "第4集", "第5集", "第6集",
      "第7集", "第8集", "第9集", "第10集", "第11集", "第12集",
    ],
    updatedAt: "2024-09-25",
  },
  {
    id: "t06",
    title: "星河纪元",
    type: "tv",
    year: 2024,
    region: "美国",
    rating: 8.8,
    views: 6120000,
    genres: ["科幻", "冒险"],
    tags: ["史诗", "星际", "文明"],
    poster:
      "https://readdy.ai/api/search-image?query=Epic%20space%20opera%20series%20poster%20of%20a%20fleet%20of%20starships%20near%20a%20giant%20orange%20planet%2C%20deep%20black%20space%2C%20dramatic%20lighting%2C%20vertical%20cinematic%20sci%20fi%20poster%20layout%2C%20highly%20detailed&width=480&height=672&seq=yz-poster-12&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Grand%20space%20opera%20scene%20with%20a%20fleet%20of%20starships%20flying%20toward%20a%20giant%20amber%20planet%2C%20deep%20dark%20space%20background%2C%20dramatic%20orange%20glow%2C%20cinematic%20wide%20shot%2C%20highly%20detailed&width=1280&height=720&seq=yz-back-12&orientation=landscape",
    summary:
      "人类文明跨入星际扩张的纪元，一支远征舰队在未知星域发现了改写历史的信号。宏大的世界观与人性抉择在星河间展开。",
    director: "Gregory Stone",
    cast: ["Ava Sterling", "Noah Bennett", "Isabella Reed"],
    duration: "全12集",
    episodes: [
      "第1集", "第2集", "第3集", "第4集", "第5集", "第6集",
      "第7集", "第8集", "第9集", "第10集", "第11集", "第12集",
    ],
    updatedAt: "2024-10-10",
    featured: true,
  },
  {
    id: "v01",
    title: "周末大玩家",
    type: "variety",
    year: 2024,
    region: "中国大陆",
    rating: 8.3,
    views: 4120000,
    genres: ["真人秀"],
    tags: ["搞笑", "游戏", "常驻嘉宾"],
    poster:
      "https://readdy.ai/api/search-image?query=Fun%20variety%20show%20poster%20with%20a%20group%20of%20cheerful%20young%20hosts%20in%20a%20colorful%20studio%20with%20warm%20orange%20lighting%2C%20playful%20energetic%20mood%2C%20deep%20dark%20background%2C%20vertical%20poster%20layout&width=480&height=672&seq=yz-poster-13&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Bright%20energetic%20tv%20studio%20stage%20with%20warm%20orange%20lights%20and%20confetti%2C%20colorful%20set%20design%2C%20dark%20background%20with%20vibrant%20accents%2C%20cinematic%20variety%20show%20wide%20shot&width=1280&height=720&seq=yz-back-13&orientation=landscape",
    summary:
      "每期一个全新主题，嘉宾们在爆笑游戏与户外挑战中互相拆台又彼此扶持，用最真实的反应承包你的周末欢乐。",
    director: "吴乐言",
    cast: ["何炅然", "谢雨辰", "王思远"],
    duration: "更新至2024-10-06期",
    episodes: [
      "2024-09-01期", "2024-09-08期", "2024-09-15期", "2024-09-22期",
      "2024-09-29期", "2024-10-06期",
    ],
    updatedAt: "2024-10-06",
  },
  {
    id: "v02",
    title: "音乐合伙人",
    type: "variety",
    year: 2023,
    region: "中国大陆",
    rating: 7.7,
    views: 1860000,
    genres: ["音乐"],
    tags: ["live", "竞演", "原创"],
    poster:
      "https://readdy.ai/api/search-image?query=Music%20competition%20show%20poster%20of%20a%20singer%20on%20stage%20under%20a%20single%20warm%20spotlight%2C%20microphone%20in%20hand%2C%20deep%20black%20background%20with%20amber%20glow%2C%20vertical%20cinematic%20poster%20layout&width=480&height=672&seq=yz-poster-14&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Concert%20stage%20with%20warm%20amber%20spotlights%20and%20a%20silhouetted%20band%2C%20smoke%20and%20light%20beams%2C%20deep%20dark%20background%2C%20cinematic%20live%20music%20wide%20shot%2C%20highly%20detailed&width=1280&height=720&seq=yz-back-14&orientation=landscape",
    summary:
      "顶尖音乐人与新生代歌手两两组队，从零打磨一首原创作品。舞台之上，是才华的碰撞，也是关于热爱的双向奔赴。",
    director: "林声",
    cast: ["周越", "许星辰", "陈思宁"],
    duration: "全12期",
    episodes: [
      "第1期", "第2期", "第3期", "第4期", "第5期", "第6期",
      "第7期", "第8期", "第9期", "第10期", "第11期", "第12期",
    ],
    updatedAt: "2024-03-30",
  },
  {
    id: "v03",
    title: "环球美食纪",
    type: "variety",
    year: 2024,
    region: "中国大陆",
    rating: 8.6,
    views: 3290000,
    genres: ["美食"],
    tags: ["旅行", "烟火气", "治愈"],
    poster:
      "https://readdy.ai/api/search-image?query=Food%20travel%20show%20poster%20of%20a%20steaming%20street%20food%20stall%20at%20night%20with%20warm%20amber%20lights%2C%20rich%20colors%20on%20a%20deep%20dark%20background%2C%20appetizing%20vertical%20poster%20layout&width=480&height=672&seq=yz-poster-15&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Night%20market%20street%20full%20of%20glowing%20food%20stalls%20and%20warm%20amber%20lanterns%2C%20rising%20steam%20and%20rich%20colors%2C%20deep%20dark%20atmosphere%2C%20cinematic%20food%20documentary%20wide%20shot&width=1280&height=720&seq=yz-back-15&orientation=landscape",
    summary:
      "跟随主厨的脚步走遍世界角落，从深夜排档到百年老店，用一道道食物讲述城市与人情的温度。",
    director: "赵味",
    cast: ["苏晓厨", "老周", "阿May"],
    duration: "更新至第8期",
    episodes: [
      "第1期 曼谷", "第2期 大阪", "第3期 成都", "第4期 伊斯坦布尔",
      "第5期 那不勒斯", "第6期 首尔", "第7期 潮汕", "第8期 巴黎",
    ],
    updatedAt: "2024-10-09",
    featured: true,
  },
  {
    id: "v04",
    title: "极限赛道",
    type: "variety",
    year: 2023,
    region: "韩国",
    rating: 8.1,
    views: 2210000,
    genres: ["竞技"],
    tags: ["赛车", "热血", "实景"],
    poster:
      "https://readdy.ai/api/search-image?query=Competition%20show%20poster%20of%20a%20race%20car%20speeding%20on%20a%20night%20track%20with%20warm%20amber%20headlights%20and%20motion%20blur%2C%20deep%20dark%20background%2C%20high%20energy%20vertical%20poster%20layout&width=480&height=672&seq=yz-poster-16&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Race%20track%20at%20night%20with%20cars%20speeding%20under%20warm%20amber%20floodlights%2C%20motion%20blur%20and%20light%20streaks%2C%20deep%20dark%20atmosphere%2C%20cinematic%20wide%20shot%2C%20highly%20detailed&width=1280&height=720&seq=yz-back-16&orientation=landscape",
    summary:
      "来自不同领域的挑战者登上专业赛道，从零基础到并肩竞速。速度与坚持之间，是对自我极限的一次次刷新。",
    director: "김민호",
    cast: ["강태오", "윤서아", "박지훈"],
    duration: "全10期",
    episodes: [
      "第1期", "第2期", "第3期", "第4期", "第5期",
      "第6期", "第7期", "第8期", "第9期", "第10期",
    ],
    updatedAt: "2024-02-14",
  },
  {
    id: "v05",
    title: "深夜脱口秀",
    type: "variety",
    year: 2024,
    region: "美国",
    rating: 7.6,
    views: 1540000,
    genres: ["脱口秀"],
    tags: ["幽默", "时评", "访谈"],
    poster:
      "https://readdy.ai/api/search-image?query=Late%20night%20talk%20show%20poster%20of%20a%20host%20at%20a%20desk%20with%20a%20microphone%20under%20warm%20amber%20stage%20light%2C%20deep%20dark%20background%2C%20elegant%20minimal%20vertical%20poster%20layout&width=480&height=672&seq=yz-poster-17&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Stylish%20late%20night%20talk%20show%20stage%20with%20a%20host%20desk%20and%20warm%20amber%20spotlights%2C%20deep%20dark%20background%20with%20accent%20lighting%2C%20cinematic%20wide%20shot%2C%20highly%20detailed&width=1280&height=720&seq=yz-back-17&orientation=landscape",
    summary:
      "一档深夜档喜剧访谈节目，用犀利的段子和真诚的对谈，聊遍当下最热的话题与最有趣的人。",
    director: "Trevor Blake",
    cast: ["Jimmy Coles", "Sara Ford", "Miles Grant"],
    duration: "更新至第120期",
    episodes: [
      "第110期", "第111期", "第112期", "第113期",
      "第114期", "第115期", "第116期", "第117期", "第118期", "第119期", "第120期",
    ],
    updatedAt: "2024-09-30",
  },
  {
    id: "v06",
    title: "燃舞之夜",
    type: "variety",
    year: 2023,
    region: "中国大陆",
    rating: 7.9,
    views: 1980000,
    genres: ["舞蹈"],
    tags: ["街舞", "battle", "青春"],
    poster:
      "https://readdy.ai/api/search-image?query=Dance%20competition%20show%20poster%20of%20a%20street%20dancer%20in%20mid%20move%20under%20warm%20amber%20stage%20light%2C%20dynamic%20pose%2C%20deep%20dark%20background%2C%20high%20energy%20vertical%20poster%20layout&width=480&height=672&seq=yz-poster-18&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Urban%20dance%20battle%20stage%20with%20dancers%20silhouetted%20under%20warm%20amber%20and%20orange%20lights%2C%20graffiti%20walls%2C%20deep%20dark%20atmosphere%2C%20cinematic%20wide%20shot%2C%20highly%20detailed&width=1280&height=720&seq=yz-back-18&orientation=landscape",
    summary:
      "来自全国的顶尖舞者同台 battle，用身体讲述热爱。每一次节拍落下，都是青春最滚烫的注脚。",
    director: "唐舞",
    cast: ["阿K", "小鹿", "Bobo"],
    duration: "全14期",
    episodes: [
      "第1期", "第2期", "第3期", "第4期", "第5期", "第6期",
      "第7期", "第8期", "第9期", "第10期", "第11期", "第12期",
    ],
    updatedAt: "2024-01-20",
  },
];